// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
// Режим вида ячеек «Signals» (signals; uk «Сигнали», ru «Сигналы») — первый в полосе видов над таблицей. Круг ячейки-даты = проблемные сигналы ячейки,
// несколько — «слоёный» круг: концентрические кольца, снаружи самый приоритетный (порядок SIGNALS_ORDER), один — сплошной круг его цвета; сигналов
// нет — круга нет (число как обычно). Размер — правило p190 (значение = значение ячейки). Сигналы — по классам оформления ячейки (ctx.cellClasses —
// грид собирает каналы: _DLRow.cells[b].cssClasses, _DLRow.cssClasses, правила оформления фронта cf_compute, cssClass-<b>, классы плана planCell_classes);
// over-100 (проценты > 100 %) добавляет cellRing_build по шкале (opts.concentric).
// В этом виде заливка ячейки от проблемных сигналов не рисуется (signals_suppress — какие классы снять с ячейки); фон остаётся от горизонтов
// lead time / replenishment cycle (cell-lt / cell-rc) и от зон запаса (stock-critical / -min / -opt / -ok / -max / -nosales) с их двойниками cell-background-*.
// Выключатель fe.ux.cellViewSignals (дефолт ВКЛ): ВЫКЛ — круги сигналов рисуются, а заливка ячеек остаётся прежней. Тесты — tests/unit/cellViews.test.mjs
import { t as tI18n } from '@/i18n'
import { CELL_RING_COLORS } from '@/utils/cellRing'

export const SIGNALS_VIEW = 'signals'
export const SIGNALS_FLAG = 'fe.ux.cellViewSignals'
// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p212 сигнал проблеми видно і в дочірніх рядках (порожня комірка), прив'язка дефіциту/попиту до міри руху)
// Ячейка без значения (строка узла, у которой в месяце только сигналы — после слияния бэком строк-сирот сигналов в строку узла, p212) — круг постоянного
// малого диаметра SIGNALS_EMPTY_D px (как «Статуси: крапка»), без шкалы: размер от пустого значения ничего не значит. Выключатель fe.ux.signalsOnEmptyCells
// (дефолт ВКЛ; грид кладёт его в ctx.emptyDot): ВЫКЛ — прежний минимальный круг по шкале
export const SIGNALS_EMPTY_FLAG = 'fe.ux.signalsOnEmptyCells'
export const SIGNALS_EMPTY_D = 8

// сигналы вида: порядок = приоритет (первый — внешнее кольцо); цвета колец — CELL_RING_COLORS (uncovered / over-100 / excess / over-max / grown) + свои
export const SIGNALS_ORDER = ['uncovered', 'over-100', 'bad', 'expired', 'excess', 'over-max', 'warning', 'grown', 'manual']
export const SIGNALS_COLORS = {
    ...CELL_RING_COLORS, bad: '#ad1457', expired: '#6d4c41', warning: '#fb8c00', manual: '#8e24aa',
}
export const SIGNALS_TITLES = {
    uncovered: 'Uncovered', 'over-100': 'Over 100 %', bad: 'Bad grade', expired: 'Expired', excess: 'Excess stock', 'over-max': 'Over maximum',
    warning: 'Warning grade', grown: 'Grown since the previous run', manual: 'Manual edit',
}
// класс оформления ячейки → сигнал; fill: true — класс сам заливает ячейку (снимается в этом виде вместе с двойником cell-background-<тон>)
const CLASS_SIGNAL = {
    'alert-uncovered': { kind: 'uncovered', tone: 'red', fill: true },
    'alert-row': { kind: 'uncovered', tone: 'red', fill: true },
    'grade-bad': { kind: 'bad', tone: 'red', fill: true },
    'kpi-bad': { kind: 'bad', tone: 'red', fill: true },
    'cell-metric-critical': { kind: 'bad', tone: 'red', fill: true },
    'alert-expired': { kind: 'expired', tone: 'orange', fill: true },
    'stock-excess': { kind: 'excess', tone: 'blue-strong', fill: true },
    'stock-over-max': { kind: 'over-max', tone: 'blue', fill: true },
    'grade-warning': { kind: 'warning', tone: 'orange', fill: true },
    'plan-manual': { kind: 'manual', tone: '', fill: false },   // треугольник-маркер остаётся
}
// классы, чья заливка в этом виде ОСТАЁТСЯ (зоны запаса), — их тон защищает двойника cell-background-<тон> от снятия
const KEEP_TONE = {
    'stock-critical': 'red', 'stock-min': 'orange', 'stock-opt': 'yellow', 'stock-max': 'green', 'stock-nosales': 'grey',
}

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const listOf = (...lists) => {
    const out = []
    for (const l of lists) {
        const arr = Array.isArray(l) ? l : (typeof l === 'string' ? l.split(/\s+/) : [])
        for (const c of arr) { const s = str(c); if (s) out.push(s) }
    }
    return out
}

// классы ячейки → сигналы без повторов в порядке приоритета: [{ kind }]
export function signals_of(...classLists) {
    const on = new Set()
    for (const c of listOf(...classLists)) {
        const s = CLASS_SIGNAL[c]
        if (s) on.add(s.kind)
    }
    return SIGNALS_ORDER.filter(k => on.has(k)).map(kind => ({ kind }))
}

// сигналы → слои круга (внешний первый): { key, title, value: 1, color, tone: 'solid' }
export function signals_layers(signals, t = tI18n) {
    const tt = typeof t === 'function' ? t : (x) => x
    const seen = new Set(), out = []
    const kinds = (Array.isArray(signals) ? signals : []).map(s => str(s && s.kind)).filter(Boolean)
    for (const k of SIGNALS_ORDER) {
        if (!kinds.includes(k) || seen.has(k)) continue
        seen.add(k)
        out.push({ key: k, title: tt(SIGNALS_TITLES[k] || k), value: 1, color: SIGNALS_COLORS[k] || '#9e9e9e', tone: 'solid' })
    }
    return out
}

// классы ячейки (classList или массив) → классы, которые в этом виде снимаются: проблемные с заливкой и их двойники cell-background-<тон>, если тон
// не держит оставшийся класс зоны запаса. Пусто — снимать нечего
export function signals_suppress(classes) {
    const arr = listOf(classes && typeof classes === 'object' && !Array.isArray(classes) && typeof classes.length === 'number' ? Array.from(classes) : classes)
    const set = new Set(arr)
    const drop = [], tones = new Set(), keep = new Set()
    for (const c of set) {
        const s = CLASS_SIGNAL[c]
        if (s && s.fill) { drop.push(c); if (s.tone) tones.add(s.tone) }
        else if (KEEP_TONE[c]) keep.add(KEEP_TONE[c])
    }
    for (const tone of tones) {
        const twin = `cell-background-${tone}`
        if (set.has(twin) && !keep.has(tone)) drop.push(twin)
    }
    return drop
}

export default {
    key: SIGNALS_VIEW,
    title: 'Signals',
    satellites: [],
    needsData: false,
    // ctx: { t, measure, value (значение ячейки), cellClasses (классы оформления ячейки — грид), emptyDot (fe.ux.signalsOnEmptyCells, p212) }
    layersOf(dataItem, binding, ctx = {}) {
        const sig = signals_of(ctx.cellClasses)
        if (!sig.length) return null
        const layers = signals_layers(sig, ctx.t || tI18n)
        const v = num(ctx.value)
        const out = { layers, value: Math.abs(v), concentric: true, signalKinds: sig.map(s => s.kind) }
        if (ctx.emptyDot !== false && (ctx.value === null || ctx.value === undefined || ctx.value === '')) out.fixedDiameter = SIGNALS_EMPTY_D   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p212 сигнал проблеми видно і в дочірніх рядках (порожня комірка), прив'язка дефіциту/попиту до міри руху)
        return out
    },
    tipOf(res, ctx = {}) {
        const t = ctx.t || tI18n
        const built = res && res.__ring && res.__ring.out && Array.isArray(res.__ring.out.layers) ? res.__ring.out.layers : null   // с over-100 от шкалы (cellRing_buildConcentric)
        const rows = (built || (Array.isArray(res && res.layers) ? res.layers : [])).map(l => ({ title: l.key === 'over-100' ? t(SIGNALS_TITLES['over-100']) : l.title, color: l.color, plain: true }))
        return { caption: t('Signals'), rows }
    },
    cacheKey(dataItem, ctx = {}) {
        return listOf(ctx.cellClasses).filter(c => CLASS_SIGNAL[c]).sort().join(' ')
    },
}
